<template>
    <div>
        <div>
            <multiselect class="form-control" v-model="modelo.idmes" :options="meses" track-by="id" label="nombre" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Seleccione mes..."></multiselect>
        </div>
    </div>
</template>

<script>
export default {
  props:{ model:Object },
  data () {
      return{
        mes:{},
        meses:[
          {id:1,nombre:'Enero'},
          {id:2,nombre:'Febrero'},
          {id:3,nombre:'Marzo'},
          {id:4,nombre:'Abril'},
          {id:5,nombre:'Mayo'},
          {id:6,nombre:'Junio'},
          {id:7,nombre:'Julio'},
          {id:8,nombre:'Agosto'},
          {id:9,nombre:'Septiembre'},
          {id:10,nombre:'Octubre'},
          {id:11,nombre:'Noviembre'},
          {id:12,nombre:'Diciembre'},
        ],
        modelo: {
          idmes: null,
        }
      }
  },
  watch:{
      'modelo.idmes': function(){this.model.idmes=this.modelo.idmes; },
  },
}
</script>